import { Component, OnInit, ChangeDetectorRef,  HostListener, DoCheck } from '@angular/core';
// DoCheck,
import {Adm000Service} from '../../../../../core/_base/_service/adm000.service';
import { ADM0008ServiceService } from '../../../../../Service/ADM0008/adm0008-service.service';
import { ADM0008Class } from '../../../../../Class/ADM0008/adm0008-class';
import { ActivatedRoute, Router,NavigationEnd } from '@angular/router';
import { MenuAsideService } from '../../../../../core/_base/layout/services/menu-aside.service';

//For CSP Project
import { Csp5010ViewComponent } from '../../../CSP/CSPViews/csp5010-view/csp5010-view.component';
import { Csp5020ViewComponent } from '../../../CSP/CSPViews/csp5020-view/csp5020-view.component';
import { MatDialog } from '@angular/material';
import { Csp5030ViewComponent } from '../../../CSP/CSPViews/csp5030-view/csp5030-view.component';
import { Csp5040ViewComponent } from '../../../CSP/CSPViews/csp5040-view/csp5040-view.component';
import { Csp5050ViewComponent } from '../../../CSP/CSPViews/csp5050-view/csp5050-view.component';
import { Csp5060ViewComponent } from '../../../CSP/CSPViews/csp5060-view/csp5060-view.component';
import { Csp5070ViewComponent } from '../../../CSP/CSPViews/csp5070-view/csp5070-view.component';
import { Csp5080ViewComponent } from '../../../CSP/CSPViews/csp5080-view/csp5080-view.component';
import { Csp5090ViewComponent } from '../../../CSP/CSPViews/csp5090-view/csp5090-view.component';

import { filter } from 'rxjs/operators';
import { MenuserviceService } from '../../../../../Service/menuservice/menuservice.service';

@Component({
  selector: 'kt-sub-module-widget',
  templateUrl: './sub-module-widget.component.html',
  styleUrls: ['./sub-module-widget.component.scss']
})
export class SubModuleWidgetComponent implements OnInit, DoCheck {

	ArrModule:any[]=[];
	subModulesSelected:any[]=[];
	pagedModules: any[] = [];
	activatedId: any;
	ModuleHeadDisplayName: any;
	ModuleHeadSubDisplayName: any;
	dialogRef: any;

	activeTileId: number | null = null;
	tileMenuItems: any[] = [];
	tileExpandedIndexes: { [key: number]: boolean } = {};
	menuCache: { [key: number]: any[] } = {};
	isTileMenuOpen = false;
	menuLoading = false;
	selectedTileTitle: string = '';
	scrollableDropdown = false;
	dropdownAlignRight = false;
	mobileDropdownStyle: { [key: string]: string } = {};
	isMobileDropdownOpen = false;
	contextMenuVisible = false;
	contextMenuX = 0;
	contextMenuY = 0;
	contextMenuItem: any = null;
	favorites: any[] = [];
	RightClickUrl: string = '';
  hoverCloseTimer: any = null;
  hoverPreviewTileId: number | null = null;
  hoverPreviewTitle: string = '';
  hoverPreviewColumns: Array<{ heading: string; items: Array<{ title: string; page: string; icon: string }> }> = [];
  hoverPreviewStyle: { [key: string]: string } = {};
  selectedTopMenuItem: number | null = null;
  topMenuItems: any[] = [];
	
  constructor(
	private changeDetectorRef: ChangeDetectorRef,
	private objAdm000Service:Adm000Service,
	private ADM0008service: ADM0008ServiceService,
	private activateRoute: ActivatedRoute,
	private router: Router,
	private menuAsideService: MenuAsideService,
	public dialog: MatDialog,
  private menuservice:MenuserviceService
	) { }

  ngOnInit() {
	this.objAdm000Service.GetModules().subscribe(dataAdm0000=>{
			var data = dataAdm0000.objADM0001;
			//this.ArrModule = data;
		//	this.activatedId = this.activateRoute.snapshot.params.id; 
			// this.subModulesSelected = this.GetSubmodules(this.activatedId);
        // this.activatedId = this.activateRoute.snapshot.paramMap.get('id');
         const url = this.router.url;

      const id = url.substring(url.lastIndexOf('/') + 1);
      const numericId = parseInt(id);

      if (!isNaN(numericId)) {
        this.activatedId = numericId;
      }
     
      this.menuservice.setMenu(dataAdm0000.UserMenus)
      // Filter and sort top level menu items
      this.topMenuItems = (dataAdm0000.UserMenus || [])
        .filter((menu: any) => menu.root === false || menu.root === true) // Get all menus
        .sort((a: any, b: any) => {
          const orderA = parseInt(a.MenuOrderNo) || 0;
          const orderB = parseInt(b.MenuOrderNo) || 0;
          return orderA - orderB;
        });
    const result = this.findMenuById(dataAdm0000.UserMenus,  this.activatedId);
    if (result) {
      this.ArrModule = this.sortMenuItemsRecursively(result.submenu || []);
      this.subModulesSelected = this.GetSubmodules(this.activatedId);
      this.updatePagedModules();
      // Set the selected top menu item based on current route
      this.selectedTopMenuItem = this.activatedId;
    }
			this.changeDetectorRef.detectChanges();
	})

  this.router.events
    .pipe(filter(event => event instanceof NavigationEnd))
    .subscribe(() => {
      const url = this.router.url;

      const id = url.substring(url.lastIndexOf('/') + 1);
      const numericId = parseInt(id);

      if (!isNaN(numericId)) {
        console.log('Navigating to module ID:', numericId);
        const menuData = this.menuservice.getMenus();
        const result = this.findMenuById(menuData, numericId);
        
        console.log('Found menu result:', result);
        
        if (result) {
          this.activatedId = numericId;
          this.ArrModule = this.sortMenuItemsRecursively(result.submenu || []);
          console.log('ArrModule set to:', this.ArrModule);
          
          this.subModulesSelected = this.GetSubmodules(numericId);
          console.log('subModulesSelected:', this.subModulesSelected);
          
          this.updatePagedModules();
          console.log('pagedModules:', this.pagedModules);
          // Update selected top menu item
          this.selectedTopMenuItem = numericId;
          this.changeDetectorRef.detectChanges();
        } else {
          console.warn('No menu found for ID:', numericId);
        }
      }
    });
	
  }

findMenuById(menus: any[], menuId: number): any | null {
  for (const menu of menus) {
    if (menu.menuid === menuId) {
      return menu;
    }

    if (menu.submenu && menu.submenu.length > 0) {
      const result = this.findMenuById(menu.submenu, menuId);
      if (result) {
        return result;
      }
    }
  }

  return null;
}

selectTopMenu(menuItem: any) {
  if (!menuItem) return;
  
  this.selectedTopMenuItem = menuItem.menuid;
  console.log('Selected menu:', menuItem.title, 'ID:', menuItem.menuid);
  
  // Navigate to widget-dashboard with the menu id
  if (menuItem.menuid) {
    this.router.navigate(['/widget/widget-dashboard', menuItem.menuid]);
  }
}

  GetSubmodules(moduleid?:any)
  {
	// alert(moduleid); 
	this.objAdm000Service.GetModuleHead(moduleid).subscribe(dataModuleHead=>{
		this.ModuleHeadDisplayName = dataModuleHead.MenuDisplayName;
		this.ModuleHeadSubDisplayName = dataModuleHead.MenuSubCaption;;
		this.changeDetectorRef.detectChanges();
	})

  //  return this.ArrModule.filter(x=>x.FkMenuId==moduleid);
     return this.ArrModule;
  }

  getTileId(subdata: any): number | null {
    const rawId = subdata && (subdata.MenuID || subdata.MenuId || subdata.menuid);
    return rawId != null ? Number(rawId) : null;
  }

  getTileTitle(subdata: any): string {
    return (subdata && (subdata.title || subdata.MenuDisplayName || subdata.Title || subdata.DisplayName)) || '';
  }

  onTileMouseEnter(event: MouseEvent, subdata: any) {
    if (window.innerWidth <= 992) {
      return;
    }

    this.clearHoverCloseTimer();
    const tileId = this.getTileId(subdata);
    if (tileId == null) {
      return;
    }
    if(tileId>0)
    {
      this.menuAsideService.setSelectedModuleId(tileId);
    }

    this.hoverPreviewTileId = tileId;
    this.hoverPreviewTitle = this.getTileTitle(subdata) || 'Sample Menu';
    this.hoverPreviewColumns = this.buildHoverPreviewColumns(subdata);
    this.hoverPreviewStyle = this.getHoverPreviewStyle(event.currentTarget as HTMLElement);
  }

  onTileMouseLeave() {
    if (window.innerWidth <= 992) {
      return;
    }

    this.scheduleHoverPreviewClose();
  }

  onTileClick(event: MouseEvent, subdata: any) {
    if ((!subdata.submenu || subdata.submenu.length === 0) && subdata.page) {
      event.stopPropagation();
     // alert('Navigating to page: ' + subdata.page);
     this.router.navigateByUrl(subdata.page);
    //  this.navigateToPageWithTitle(subdata);
      return;
    }

    // On mobile/tablet there is no mouseenter/mouseleave (hover preview is disabled
    // below 992px, see onTileMouseEnter/onTileMouseLeave and the tile-hover-preview
    // CSS), so tapping the tile has to open the same dropdown menu hover reveals on
    // desktop - reuses openTileMenu, which already has its own mobile positioning.
    if (window.innerWidth <= 992) {
      this.openTileMenu(event, subdata);
    }
  }

  onTileDropdownMouseEnter() {
    this.clearHoverCloseTimer();
  }

  onTileDropdownMouseLeave() {
  }

  onHoverPreviewMouseEnter() {
    this.clearHoverCloseTimer();
  }

  onHoverPreviewMouseLeave() {
    if (window.innerWidth <= 992) {
      return;
    }

    this.scheduleHoverPreviewClose();
  }

  onHoverPreviewItemClick(item: any, event: MouseEvent) {
    event.stopPropagation();
    if (!item || !item.page) {
      return;
    }

    this.navigateToPageWithTitle(item);
    this.closeHoverPreview();
  }

  // Sort column items by MenuOrderNo in ascending order
  getSortedColumnItems(items: any[]): any[] {
    if (!items || items.length === 0) {
      return [];
    }
    return items.sort((a, b) => {
      const orderA = Number(a.MenuOrderNo) || 0;
      const orderB = Number(b.MenuOrderNo) || 0;
      return orderA - orderB;
    });
  }

  // Recursively sort menu items and their submenu by MenuOrderNo
  private sortMenuItemsRecursively(items: any[]): any[] {
    if (!items || items.length === 0) {
      return [];
    }
    
    // Sort current level
    const sorted = items.sort((a, b) => {
      const orderA = Number(a.MenuOrderNo) || 0;
      const orderB = Number(b.MenuOrderNo) || 0;
      return orderA - orderB;
    });
    
    // Sort submenu recursively
    sorted.forEach(item => {
      if (item.submenu && Array.isArray(item.submenu) && item.submenu.length > 0) {
        item.submenu = this.sortMenuItemsRecursively(item.submenu);
      }
    });
    
    return sorted;
  }

  openTileMenu(event: MouseEvent, subdata: any) {
    event.stopPropagation();
    this.clearHoverCloseTimer();

    const tileId = this.getTileId(subdata);
    if (tileId == null) {
      return;
    }

    const tileEl = event.currentTarget as HTMLElement;
    const isMobile = window.innerWidth <= 992;
    this.dropdownAlignRight = false;
    this.mobileDropdownStyle = {};
    this.isMobileDropdownOpen = isMobile;

    if (isMobile && tileEl) {
      const tileRect = tileEl.getBoundingClientRect();
      const horizontalGutter = 32;
      const dropdownWidth = Math.min(window.innerWidth - horizontalGutter, 520);
      const topPos = tileRect.bottom + 8;
      const maxTop = window.innerHeight - 140;
      const targetLeft = tileRect.left + tileRect.width / 2 - dropdownWidth / 2;
      const leftPos = Math.min(Math.max(targetLeft, 16), window.innerWidth - dropdownWidth - 16);
      this.mobileDropdownStyle = {
        position: 'fixed',
        top: `${Math.min(Math.max(topPos, 16), maxTop)}px`,
        left: `${leftPos}px`,
        width: `${dropdownWidth}px`,
        maxWidth: `${dropdownWidth}px`,
        boxSizing: 'border-box',
        zIndex: '1300'
      };
    }

    if (!isMobile && tileEl) {
      const tileRect = tileEl.getBoundingClientRect();
      const containerRect = tileEl.parentElement ? tileEl.parentElement.getBoundingClientRect() : document.documentElement.getBoundingClientRect();
      const dropdownMaxWidth = 460;
      if ((tileRect.right + dropdownMaxWidth + 16) > containerRect.right) {
        this.dropdownAlignRight = true;
      }
    }

    if (this.activeTileId === tileId && this.isTileMenuOpen) {
      this.closeTileMenu();
      return;
    }

    if ([3001, 3002, 3003, 3004, 3005, 3006, 3007, 3008, 3009].includes(tileId)) {
      this.GoToDashBoard(tileId);
      return;
    }

    this.activeTileId = tileId;
    this.menuAsideService.setSelectedModuleId(tileId);
    this.selectedTileTitle = this.getTileTitle(subdata);
    this.tileExpandedIndexes = {};
    this.isTileMenuOpen = true;

    const cachedMenu = this.menuCache[tileId];
    if (cachedMenu) {
      this.tileMenuItems = cachedMenu;
      const itemCount = this.tileMenuItems.reduce((count, item) => count + 1 + (item.submenu.length || 0), 0);
      this.scrollableDropdown = itemCount > 6;
      this.menuLoading = false;
      this.changeDetectorRef.detectChanges();
      return;
    }

    this.tileMenuItems = [];
    this.menuLoading = true;

    this.objAdm000Service.GetMenu(tileId).subscribe(data => {
     
      this.tileMenuItems = this.sortMenuItemsRecursively(data || []);
      this.menuCache[tileId] = this.tileMenuItems;
      const itemCount = this.tileMenuItems.reduce((count, item) => count + 1 + (item.submenu.length || 0), 0);
      this.scrollableDropdown = itemCount > 6;
      this.menuLoading = false;
      this.changeDetectorRef.detectChanges();
    }, () => {
      this.scrollableDropdown = false;
      this.menuLoading = false;
      this.changeDetectorRef.detectChanges();
    });
  }

  closeTileMenu() {
    this.clearHoverCloseTimer();
    this.activeTileId = null;
    this.tileMenuItems = [];
    this.isTileMenuOpen = false;
    this.selectedTileTitle = '';
    this.scrollableDropdown = false;
    this.dropdownAlignRight = false;
    this.mobileDropdownStyle = {};
    this.isMobileDropdownOpen = false;
    this.closeContextMenu();
  }

  closeHoverPreview() {
    this.clearHoverCloseTimer();
    this.hoverPreviewTileId = null;
    this.hoverPreviewTitle = '';
    this.hoverPreviewColumns = [];
    this.hoverPreviewStyle = {};
  }

  private scheduleHoverPreviewClose() {
    this.clearHoverCloseTimer();
    this.hoverCloseTimer = setTimeout(() => {
      this.closeHoverPreview();
    }, 180);
  }

  private clearHoverCloseTimer() {
    if (this.hoverCloseTimer) {
      clearTimeout(this.hoverCloseTimer);
      this.hoverCloseTimer = null;
    }
  }

  private buildHoverPreviewColumns(subdata: any): Array<{ heading: string; items: Array<{ title: string; page: string; icon: string }> }> {
    const sections = (subdata && Array.isArray(subdata.submenu) ? subdata.submenu : []) as any[];
    if (!sections.length) {
      return [];
    }

    return sections.map((section: any) => {
      const heading = section && (section.title || section.MenuDisplayName || section.Title || 'Menu');
      const children = section && Array.isArray(section.submenu) ? section.submenu : [];
      
      // Sort children by MenuOrderNo before mapping
      const sortedChildren = children.sort((a: any, b: any) => {
        const orderA = Number(a.MenuOrderNo) || 0;
        const orderB = Number(b.MenuOrderNo) || 0;
        return orderA - orderB;
      });
      
      const items = sortedChildren
        .map((child: any) => {
          const title = child && (child.title || child.MenuDisplayName || child.Title);
          const page = child && child.page;
          if (!title || !page) {
            return null;
          }

          return {
            title,
            page,
            icon: child.icon || child.IconTag || 'fa fa-circle',
            MenuOrderNo: child.MenuOrderNo
          };
        })
        .filter((entry: any) => !!entry);

      return {
        heading,
        items
      };
    });
  }

  private getHoverPreviewStyle(tileEl: HTMLElement): { [key: string]: string } {
    const tileRect = tileEl.getBoundingClientRect();
    const previewWidth = 900;
    const viewportWidth = window.innerWidth;
    const padding = 20;
    const gap = 12;

    // Position below the hovered tile with gap
    const topPos = tileRect.bottom + gap;

    // The preview must never extend past the right edge of .menu-full-row
    // (the menu block itself) - fall back to the viewport edge if that
    // ancestor isn't found for some reason.
    const menuRowEl = tileEl.closest('.menu-full-row') as HTMLElement | null;
    const rightBoundary = (menuRowEl ? menuRowEl.getBoundingClientRect().right : viewportWidth) - padding;

    // Anchor to the hovered tile itself (not the grid/container), so the
    // menu always opens directly under the submodule the user is pointing
    // at, rather than always sliding back to the left edge of the row.
    const finalWidth = Math.min(previewWidth, viewportWidth - (2 * padding));
    let leftPos = tileRect.left;

    // Keep it inside the menu block: pull back off its right edge first...
    if (leftPos + finalWidth > rightBoundary) {
      leftPos = rightBoundary - finalWidth;
    }
    // ...then make sure that didn't push it past the left edge.
    if (leftPos < padding) {
      leftPos = padding;
    }

    return {
      position: 'fixed',
      top: `${topPos}px`,
      left: `${leftPos}px`,
      right: 'auto',
      width: `${finalWidth}px`,
      maxWidth: `${finalWidth}px`,
      maxHeight: '390px',
      boxSizing: 'border-box',
      zIndex: '9999'
    };
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent) {
    const target = event.target as HTMLElement;
    if (!target.closest('.tile-card') && !target.closest('.tile-dropdown')) {
      this.closeTileMenu();
    }
  }

  toggleTileDropdownItem(item: any, index: number, event: MouseEvent) {
    event.stopPropagation();
    if (item.submenu.length) {
      this.tileExpandedIndexes[index] = !this.tileExpandedIndexes[index];
      return;
    }

    if (item.page) {
      this.navigateToPageWithTitle(item);
      this.closeTileMenu();
    }
  }

  onTileSubMenuClick(item: any, event: MouseEvent) {
    event.stopPropagation();
    if (item.page) {
      this.navigateToPageWithTitle(item);
    }
    this.closeTileMenu();
  }

  private navigateToPageWithTitle(item: any) {
    if (!item || !item.page) {
      return;
    }

    if (this.activeTileId != null) {
      this.menuAsideService.setSelectedModuleId(this.activeTileId);
    }

    let pagePath = item.page;
    if (!pagePath.startsWith('/') && !pagePath.startsWith('./') && !pagePath.startsWith('../')) {
      pagePath = '/' + pagePath;
    }

    const pageTitle = this.getPageTitle(item);
    const encodedTitle = encodeURIComponent(pageTitle);
    
    // Always add tabTitle parameter if we have a title
    if (encodedTitle && encodedTitle.length > 0) {
      const separator = pagePath.includes('?') ? '&' : '?';
      const url = `${pagePath}${separator}tabTitle=${encodedTitle}`;
      this.router.navigateByUrl(url);
    } else {
      // Fallback if no title
      this.router.navigateByUrl(pagePath);
    }
  }

  onMenuItemRightClick(item: any, event: MouseEvent) {
    event.preventDefault();
    event.stopPropagation();
    if (!item || !item.page) {
      this.closeContextMenu();
      return;
    }

    this.contextMenuItem = item;
    this.RightClickUrl = item.page || '';

    if (!this.canShowContextMenu(item)) {
      this.closeContextMenu();
      return;
    }

    this.contextMenuX = event.clientX;
    this.contextMenuY = event.clientY;
    this.contextMenuVisible = true;
  }

  canShowContextMenu(item: any): boolean {
    return !!item && !!item.page;
  }

  private getPageTitle(item: any): string {
    if (!item) {
      return '';
    }
    
    // Try common title properties first
    if (item.title) return item.title;
    if (item.MenuDisplayName) return item.MenuDisplayName;
    if (item.Title) return item.Title;
    if (item.DisplayName) return item.DisplayName;
    if (item.name) return item.name;
    if (item.label) return item.label;
    
    // Fallback: extract from page URL if all else fails
    if (item.page) {
      return item.page.split('/').filter((p: string) => p.length > 0).pop() || '';
    }
    
    return '';
  }

  private getPageUrlWithTitle(item: any): string {
    const page = item.page || '';
    const title = encodeURIComponent(this.getPageTitle(item));
    const separator = page.includes('?') ? '&' : '?';
    return '/#' + page + (title ? `${separator}tabTitle=${title}` : '');
  }

  openInNewWindow(item: any) {
    if (item && item.page) {
      window.open(this.getPageUrlWithTitle(item), '_blank');
    }
    this.closeContextMenu();
  }

  addToFavorite(item: any) {
    if (!item || !item.page) {
      this.closeContextMenu();
      return;
    }

    const classobj = new ADM0008Class();
    classobj.PageUrl = this.RightClickUrl;

    this.ADM0008service.Create(classobj).subscribe(data => {
      if (data.IsSuccess) {
        console.log('Added to favorites successfully');
      } else {
        if (data.ErrorCodes === 'Duplication') {
          console.log('Already in favorites');
        } else {
          console.log('Error adding to favorites:', data.ErrorCodes);
        }
      }
    });

    this.closeContextMenu();
  }

  closeContextMenu() {
    this.contextMenuVisible = false;
    this.contextMenuItem = null;
  }

  @HostListener('document:click', ['$event'])
  onDocumentClickContext(event: MouseEvent) {
    if (this.contextMenuVisible) {
      const target = event.target as HTMLElement;
      if (!target.closest('.context-menu')) {
        this.closeContextMenu();
      }
    }
  }

  getTileIcon(subdata: any): string {
    return subdata.MenuIcon || subdata.icon || subdata.IconTag || this.iconMap[subdata.MenuDisplayName] || 'fa-solid fa-people-simple';
  }

  iconMap: { [key: string]: string } = {
    'Employee Management': 'fa-solid fa-user-group',
    'Day Book': 'fa-solid fa-book',
    'Leave Management': 'fa-solid fa-calendar-days',
    'Loans & Prepayments': 'fa-solid fa-hand-holding-dollar',
    'Settlements': 'fa-solid fa-file-invoice-dollar',
    'Payroll Management': 'fa-solid fa-credit-card',
    'Employee Accruals': 'fa-solid fa-coins',
    'Task Management': 'fa-solid fa-tasks',
    'Dashboard': 'fa-solid fa-tachometer-alt',
    'Approvals': 'fa-solid fa-check-circle',
    'Reports & Analytics': 'fa-solid fa-chart-line',
    'Administration': 'fa-solid fa-cog',
    'Settings': 'fa-solid fa-gear'
  };

  GoToDashBoard(ModuleId: number)
  {
    if(ModuleId == 3001)
    {
        this.dialogRef = this.dialog.open(Csp5010ViewComponent,
        {
        width: "95%",
        height: "95%",
        // data: this.objAnnouncementDatails,
        }  
        );  
    }
 
     else if(ModuleId == 3002)
    {
        this.dialogRef = this.dialog.open(Csp5020ViewComponent,
        {
        width: "90%",
        height: "90%",
        // data: this.objAnnouncementDatails,
        }  
        );  
    }
 
   
     else if(ModuleId == 3003)
    {
        this.dialogRef = this.dialog.open(Csp5030ViewComponent,
        {
        width: "90%",
        height: "90%",
        // data: this.objAnnouncementDatails,
        }  
        );  
    }
 
   
     else if(ModuleId == 3004)
    {
        this.dialogRef = this.dialog.open(Csp5040ViewComponent,
        {
        width: "90%",
        height: "90%",
        // data: this.objAnnouncementDatails,
        }  
        );  
    }
 
     else if(ModuleId == 3005)
    {
        this.dialogRef = this.dialog.open(Csp5050ViewComponent,
        {
        width: "90%",
        height: "90%",
        // data: this.objAnnouncementDatails,
        }  
        );  
    }
 
     else if(ModuleId == 3006)
    {
        this.dialogRef = this.dialog.open(Csp5060ViewComponent,
        {
        width: "90%",
        height: "90%",
        // data: this.objAnnouncementDatails,
        }  
        );  
    }
 
     else if(ModuleId == 3007)
    {
        this.dialogRef = this.dialog.open(Csp5070ViewComponent,
        {
        width: "90%",
        height: "90%",
        // data: this.objAnnouncementDatails,
        }  
        );  
    }
 
    else if(ModuleId == 3008)
    {
        this.dialogRef = this.dialog.open(Csp5080ViewComponent,
        {
        width: "90%",
        height: "90%",
        // data: this.objAnnouncementDatails,
        }  
        );  
    }
 
    else if(ModuleId == 3009)
    {
        this.dialogRef = this.dialog.open(Csp5090ViewComponent,
        {
        width: "90%",
        height: "70%",
        // data: this.objAnnouncementDatails,
        }  
        );  
    }
 
 
 
 
    else
    {
        // no action here; other modules open their menu from the tile directly
    }
 
    // if(ModuleId==900){
    //                     debugger;
    //                     localStorage.setItem('ModuleId', JSON.stringify(ModuleId));  //Module ID
    //                     this.router.navigate(['/dashboard'], { queryParams: { moduleId: ModuleId } });      
    //                 }
    //              else{
    //                     this.dialogRef = this.dialog.open(Tsk5020NewComponent, {
    //                     width: "1000px",
    //                     height: "600px",
    //                     // data: this.objAnnouncementDatails,
    //                  }
    //     );
    //     }
    // window.location.href='/dashboard';
  }
 

//   GoToDashBoard(ModuleId)
//   {
//     // alert(ModuleId);
//     localStorage.setItem('ModuleId', JSON.stringify(ModuleId));  //Module ID
//     // alert(localStorage.getItem('ModuleId'));
// 	this.router.navigate(['/dashboard'], { queryParams: { moduleId: ModuleId } });
//     // window.location.href='/dashboard'; 
//   }

  ngDoCheck(): void {

	//Called every time that the input properties of a component or a directive are checked. Use it to extend change detection by performing a custom check.
	//Add 'implements DoCheck' to the class.
	this.activatedId = this.activateRoute.snapshot.params.id;
	this.subModulesSelected = this.GetSubmodules(this.activatedId);
	this.updatePagedModules();
	this.changeDetectorRef.detectChanges();
  }

updatePagedModules() {
  // Show every submodule in the menu block - no pagination, nothing hidden.
  this.pagedModules = this.subModulesSelected;
  console.log('updatePagedModules called - pagedModules length:', this.pagedModules.length);
}



}
